import { Link } from 'react-router-dom';
import './playerTagPicker.css';

export default function PlayerTagsInline({ taggedPlayers = [] }) {
  const visibleTags = (Array.isArray(taggedPlayers) ? taggedPlayers : []).filter(
    (tag) => tag?.playerId,
  );

  if (!visibleTags.length) return null;

  return (
    <div className="playerTagsInline" aria-label="Tagged players">
      <span className="playerTagsInlineLabel">Tagged</span>
      {visibleTags.map((tag) => (
        <Link
          key={String(tag.player || tag._id || tag.playerId)}
          className="playerTagsInlineChip"
          to={`/profile/${tag.playerId}`}
        >
          @{tag.playerId}
        </Link>
      ))}
    </div>
  );
}
